<div class="tile__status tile__status--active" data-testid="tile">
    <div class="tile__svg--other-wrapper bg-img">
        <img class="tile__svg--other" ngSrc="/assets/img/id_icons/77.svg"
             width="50" height="50" alt="" />
    </div>
    <div class="tile__title-wrapper">
        <p class="tile__title tile__title--date tile__title--long"
           *ngIf="subtitles.downloaded">
           {{ (tile.params.dayId | weekDay) + ', '+ tile.params.day + ' '
                + (subtitle(1792)| monthName:tile.params.month) + ' '
                + tile.params.year }}
        </p>
        <p class="tile__title tile__title--date tile__title--long font-26 font-bold color-style"
            data-testid="tile-value">
            {{ tile.params.hours + ':' }}{{ tile.params.minutes | double }}
        </p>
    </div>
    <div class="tile__setting cursor-pointer"
         [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
           {{ subtitle(3162) }}
        </p>
    </div>
</div>
